
import { useState, useCallback, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Faq } from "@/types/faq-types";
import { useToast } from "@/components/ui/use-toast";

export const useFaqsLoader = () => {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const loadedRef = useRef(false);

  const loadFaqs = useCallback(async () => {
    // Prevent duplicate loading if faqs are already being loaded
    if (loading) return;
    
    setLoading(true);
    try {
      console.log("Loading FAQs...");
      const { data, error } = await supabase
        .from('faqs')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) {
        throw error;
      }

      console.log("FAQs loaded successfully:", data?.length || 0, "items");
      setFaqs(data || []);
      loadedRef.current = true;
    } catch (error: any) {
      console.error("Error loading FAQs:", error);
      toast({
        variant: "destructive",
        title: "Error loading FAQs",
        description: error.message || "An unknown error occurred"
      });
    } finally {
      setLoading(false);
    }
  }, [toast, loading]);

  return {
    faqs,
    loading,
    loadFaqs,
    setFaqs,
    isLoaded: loadedRef.current
  };
};
